import React, { FunctionComponent } from 'react';
import { hot } from 'react-hot-loader/root';
import { I18nextProvider } from 'react-i18next';
import { i18n } from 'i18next';
import { AppProvider } from './context';
import PageType from './pages/PageType/PageType';
import { PageAlertOnlyWrapper } from './components/PageAlertOnlyWrapper/PageAlertOnlyWrapper';

type AppProps = {
  i18n: i18n;
};

const App: FunctionComponent<AppProps> = ({ i18n }) => (
  <I18nextProvider i18n={i18n}>
    <AppProvider>
      <PageAlertOnlyWrapper>
        <PageType />
      </PageAlertOnlyWrapper>
    </AppProvider>
  </I18nextProvider>
);

export default hot(App);
